// src/utils/GtmEvents.js

const isGtmEnabled = () => {
    return typeof window !== 'undefined' &&
        window.dataLayer &&
        process.env.NODE_ENV !== 'development' &&
        !window.location.hostname.includes('localhost');
};

export const pushToDataLayer = (event) => {
    if (isGtmEnabled()) {
        window.dataLayer.push(event);
    } else {
        console.debug('[GTM disabled] Event:', event);
    }
};

// ------------------------------
// AUTH / LOGIN EVENTS
// ------------------------------

export const gtmLoginSuccess = () => pushToDataLayer({ event: 'ac_general_login_ok' });

export const gtmUserAlreadyLoggedIn = () => pushToDataLayer({ event: 'user_already_logged_in' });

export const gtmOtpRequestSent = () =>
    pushToDataLayer({
        event: 'otp_request_sent',
        category: 'Login',
        action: 'Request OTP',
        label: 'OTP requested'
    });

export const gtmOtpRequestFailed = () =>
    pushToDataLayer({
        event: 'otp_request_failed',
        category: 'Login',
        action: 'Request OTP Failed',
        label: 'Invalid email or phone'
    });

export const gtmOtpVerificationSuccess = () =>
    pushToDataLayer({
        event: 'otp_verification_success',
        category: 'Login',
        action: 'OTP Verified',
        label: 'User logged in successfully'
    });

export const gtmOtpVerificationFailed = () =>
    pushToDataLayer({
        event: 'otp_verification_failed',
        category: 'Login',
        action: 'OTP Verification Failed',
        label: 'Invalid OTP entered'
    });

export const gtmOtpVerificationError = () =>
    pushToDataLayer({
        event: 'otp_verification_error',
        category: 'Login',
        action: 'OTP Verification Error',
        label: 'Error during OTP verification'
    });

export const gtmOtpResent = () =>
    pushToDataLayer({
        event: 'otp_resent',
        category: 'Login',
        action: 'Resend OTP',
        label: 'OTP resent to user'
    });

export const gtmOtpResendFailed = () =>
    pushToDataLayer({
        event: 'otp_resend_failed',
        category: 'Login',
        action: 'Resend OTP Failed',
        label: 'Error while resending OTP'
    });

// ------------------------------
// LEAD EVENTS
// ------------------------------

export const gtmLeadSubmissionOK = (token) =>
    pushToDataLayer({
        event: 'lead_ac_submission_ok',
        token: token
    });

// ------------------------------
// DASHBOARD EVENTS
// ------------------------------

export const gtmDashboardPageView = () =>
    pushToDataLayer({
        event: 'dashboard_page_view',
        page: 'Dashboard'
    });

// ------------------------------
// PROCESS EVENTS
// ------------------------------

export const gtmProcessDataFetched = (processId) =>
    pushToDataLayer({
        event: 'process_data_fetched',
        processId: processId,
        status: 'success'
    });

export const gtmProcessDataNotFound = () =>
    pushToDataLayer({
        event: 'process_data_not_found',
        status: 'no_data'
    });

export const gtmProcessDataFetchError = (errorMessage) =>
    pushToDataLayer({
        event: 'process_data_fetch_error',
        status: 'error',
        errorMessage: errorMessage
    });

// ------------------------------
// LEAD FORM EVENTS
// ------------------------------

export const gtmAddSecondHolderClick = () =>
    pushToDataLayer({
        event: 'add_second_holder_click',
        category: 'Lead Form',
        action: 'Add Second Holder',
        label: 'Add Second Holder Button Clicked'
    });

export const gtmSimulateProcessClick = () =>
    pushToDataLayer({
        event: 'simulate_process_click',
        category: 'Lead Form',
        action: 'Simulate Process',
        label: 'Simulate Process Button Clicked'
    });

export const gtmOnlySimulationClick = () =>
    pushToDataLayer({
        event: 'only_simulation_click',
        category: 'Lead Form',
        action: 'Only Simulation',
        label: 'Only Simulation Button Clicked'
    });

export const gtmPreApprovalClick = () =>
    pushToDataLayer({
        event: 'pre_approval_click',
        category: 'Lead Form',
        action: 'Pre-Approval',
        label: 'Pre-Approval Button Clicked'
    });

export const gtmNextStepClick = (currentStep) =>
    pushToDataLayer({
        event: 'next_step_click',
        category: 'Lead Form',
        action: 'Next Step',
        label: `Moved to Step ${currentStep + 1}`
    });

export const gtmPrevStepClick = (currentStep) =>
    pushToDataLayer({
        event: 'prev_step_click',
        category: 'Lead Form',
        action: 'Previous Step',
        label: `Moved to Step ${currentStep - 1}`
    });

export const gtmPreApprovalWithData = (data) =>
    pushToDataLayer({
        event: 'pre_approval_click',
        processId: data.id,
        creditType: data.creditType,
        state: data.state
    });

export const gtmDocumentSubmitClick = (processId, data) =>
    pushToDataLayer({
        event: 'document_submit_click',
        processId: processId,
        creditType: data.creditType,
        state: data.state
    });